export const PROCESSOR_ONLY = 'Processor only';
export const PROCESSOR_PLUS = 'Processor plus';
export const PROGRAM_MANAGED = 'Program managed';
export const UNKNOWN = 'Unknown';
